export const environment = {
    production: false,
    apiUrl: 'https://everbrite.api.dev.viuto-aiot.com',
    omniId: 'BC241195477F',
    mqtt: {
        hostname: '10.0.5.52',
        port: 15675,
        protocol: 'ws'
    },
    vncHost: '192.168.105.6',
    showSmtpSettings: true
};
